export default __webpack_public_path__ + "static/Royal-Stamp-logo-black-69327093ccd48cb09d7c5e343a8fe89b.svg";